import { chipInteractionHint } from '#components/chip-interaction-hint/chip-interaction-hint.module.css';

import clsx from 'clsx';

export function ChipInteractionHint() {
	return (
		<>
			<span
				className={clsx(
					chipInteractionHint,
					'pointer-events-none absolute inset-0 rounded-full [animation-delay:600ms]',
				)}
			/>
			<span className='pointer-events-none absolute top-0 right-0 size-1.5 translate-x-[20%] translate-y-[-15%] rounded-full bg-orange-9 shadow-[0px_0px_4px_--theme(--color-orange-10)]' />
		</>
	);
}
